import React from 'react';
import {useTheme} from "@mui/material/styles";
import {Typography} from "@mui/material";
import {numberWithCommas} from "@/lib/helper-functions";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActionArea from "@mui/material/CardActionArea";
import Box from "@mui/material/Box";
import {IsacoTypes} from '@/types/isaco';

export default function IsacoListItem({name, car, code, price}: IsacoTypes) {
    const theme = useTheme()

    const KeyValueInline = ({keyName, value}: { keyName: string, value: string }) => (
        <Box display = "flex" gap = {2} justifyContent = {{xs: 'space-between'}} >
            <Typography noWrap fontSize = {14} mr = {.5} color = {theme.palette.grey[500]} >{keyName}:</Typography >
            <Typography
                sx={{
                    fontFamily: keyName.includes('کد‌فنی') ? "var(--font-sahel-en)" : undefined,
                }}
                fontSize={14}
                noWrap
            >
                {value}
            </Typography>

        </Box >
    )


    const PriceBox = ({keyName, value, reversed}: { keyName: string, value: number, reversed?: boolean }) => {
        return (
            <Box
                display = "flex"
                justifyContent = "space-between"
                gap = {2}
                width = {220}
                flexDirection = {{xs: 'column', md: 'row'}}
                alignItems = {{xs: reversed ? 'end' : 'start', md: 'center'}}
            >
                <Typography fontSize = {12} mr = {{md: 2, sm: 0}} color = {theme.palette.grey[500]} >
                    {keyName}
                </Typography >
                <Box fontSize = {16} fontWeight = {400} color = {theme.palette.primary.main} >
                    {numberWithCommas(value)}
                    {/*<span style = {{fontSize: 14}} > ریال </span >*/}

                </Box >
            </Box >
        )
    }

    return (

        <Card
            variant = 'outlined'
            sx = {{
                borderTop: 0,
                borderRight: 0,
                borderLeft: 0,
                boxShadow: "none",
                borderRadius: 0
            }} >
            <CardActionArea >
                <CardContent
                    sx = {{
                        display: 'flex',
                        flexDirection: {xs: 'column', sm: 'column', md: 'row', xl: 'row'},
                        justifyContent: 'space-between',
                        py: 2,
                        px: {md:2,xs:1}

                    }}
                >
                    <Box
                        display = "flex"
                        flexDirection = "column"
                        justifyContent = "space-between"
                        gap = {2}
                    >
                        <Typography
                            fontWeight = {400}
                            fontSize = {14}
                            textAlign = {{xs: 'center', md: 'justify'}}
                        >
                            {name}
                        </Typography >
                        <Box display = "flex" flexDirection = {{xs: 'column', md: 'row'}} gap = {{md: 4, xs: 2}} >
                            <KeyValueInline keyName = 'نوع خودرو' value = {car} />
                            <KeyValueInline keyName = 'کد‌فنی' value = {code} />
                        </Box >
                    </Box >
                    <Box
                        display = "flex"
                        justifyContent = "space-between"
                        flexDirection = {{xs: 'row', md: 'column'}}
                        gap = {1}
                        mt = {{md: 0, xs: 2}}
                    >
                        <PriceBox keyName = 'قیمت بدون مالیات' value = {price} />
                        <PriceBox reversed keyName = 'با احتساب مالیات' value = {Math.round(price * 1.10)} />
                    </Box >
                </CardContent >
            </CardActionArea >
        </Card >
    );
};

